<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let options: { value: string; label: string }[] = [];
    export let disabled: boolean = false;
    export let required: boolean = false;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (required && !val) {
            errors[name].push('Please select an option');
        }
    };
    validate();

    onDestroy(() => { errors[name] = []; });
</script>

<div class="form-field">
    <fieldset>
        {#if label}<legend>{label}</legend>{/if}
        {#each options as opt}
            <label class="radio-label">
                <input
                    type="radio"
                    {name}
                    {disabled}
                    value={opt.value}
                    bind:group={value}
                    on:change={() => validate(value)}
                    on:blur
                />
                <span>{opt.label}</span>
            </label>
        {/each}
    </fieldset>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</div>
